import React, { useState } from 'react';
import GameHeader from '../other_components/GameHeader';

const MosaicPage = ({
  pageData,
  gameStatus,
  onDecisionSelect,
  displayButton = true,
  editMode = false,
  onEditDecision,
  onAddDecision,
  onEditScoreConfig,
}) => {
  const [selectedDecisions, setSelectedDecisions] = useState([]); // État pour suivre les décisions sélectionnées
  const [valideConstraint, setValidConstraint] = useState(true)
  const [updatedScores, setUpdatedScores] = useState({}); // État pour la modification en directe de score


  const [listDisplayScore, setlistDisplayScore] = useState(() => {
    const DisplayScore = pageData.content.display_score_decisions || [];
    return DisplayScore.map(scoreObj => ({
      ...scoreObj,
      value: gameStatus.score_dic[scoreObj.score_id]?.value || 0
    }))
  }
  );
  const listIndicators = pageData.content.list_additional_indicators || [];




  // Préparer les données à retourner
  const prepareReturnData = () => {
    return {
      page_id: pageData._id,
      page_type: pageData.type,
      page_general_consequence: pageData.page_general_consequence,
      round: pageData.round,
      content: {
        decision_list: pageData.content.list_decisions.map((decision) => ({
          ...decision,
          taken: selectedDecisions.some((selected) => selected._id === decision._id),
        })),
        updated_score : updatedScores
      }
    };
  };

  const handleDecisionClick = (decision) => {
    if (editMode) return; // en édition, le clic sur la carte ne sélectionne pas — seul le crayon agit
    if (!displayButton) return; // partie terminée : plus rien à valider, cocher une case ne serait qu'un leurre
    if (selectedDecisions.some((selected) => selected._id === decision._id)) {
      // Retire une décision déjà sélectionnée
      setSelectedDecisions(selectedDecisions.filter((selected) => selected._id !== decision._id));
  
      setlistDisplayScore((prevScores) => {
        let newScores = prevScores.map((scoreObj) => {
          const impact_dic = decision.score[scoreObj.score_id] ?? { impact: 0 };
          return {
            ...scoreObj,
            value: (scoreObj.value || 0) - impact_dic.impact
          };
        });
  
        // Vérification des seuils après mise à jour
        const valid = newScores.every(score => 
          score.threshold === undefined || score.value >= score.threshold
        );
        setValidConstraint(valid);
  
        return newScores;
      });
    } else {
      // Ajoute une décision
      setSelectedDecisions([...selectedDecisions, decision]);
  
      setlistDisplayScore((prevScores) => {
        let newScores = prevScores.map((scoreObj) => {
          const impact_dic = decision.score[scoreObj.score_id]?? { impact: 0 };
          return {
            ...scoreObj,
            value: (scoreObj.value || 0) + impact_dic.impact
          };
        });
  
        // Vérification des seuils après mise à jour
        const valid = newScores.every(score => 
          score.threshold === undefined || score.value >= score.threshold
        );
        setValidConstraint(valid);
  
        return newScores;
      });
    }
  };
  

  // Valider et transmettre les données
  const handleValidation = () => {
    if (selectedDecisions.length > 0) {
      const preparedData = prepareReturnData();
      onDecisionSelect(preparedData); // Envoie les données transformées au parent
    } else {
      alert("Veuillez sélectionner au moins une option avant de valider.");
    }
  };

  const isExactEight = pageData.content.list_decisions.length === 8;

  return (
    <div className="page-general-container">
      <div className='page-general-background-color'></div>

      <div className='page-general-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
          <div className='page-general-background-image' style={{ backgroundImage: `url(${pageData.content.background_image_url})` }}></div>
      </div>
      <div className='page-main-content'>
        <GameHeader gameStatus={gameStatus} listScore={listDisplayScore} pageName={pageData.title}></GameHeader>

        {editMode && (
          <button
            className="builder-edit-fab builder-edit-fab-scores"
            onClick={onEditScoreConfig}
            title="Configurer les scores affichés sur les décisions"
          >⚙️ Scores affichés</button>
        )}

        <div className={`mosaic-list ${isExactEight ? 'grid-2x4' : 'flex-wrap'}`}>
          {pageData.content.list_decisions.map((decision, index) => (
            <div
              key={index}
              className={`mosaic-decision ${
                selectedDecisions.some((selected) => selected._id === decision._id)
                  ? 'mosaic-decision-selected'
                  : ''
              } ${editMode ? 'builder-editable-card' : ''}`}
              onClick={() => handleDecisionClick(decision)}
            >
              {editMode && (
                <button
                  className="builder-edit-fab builder-edit-fab-card"
                  onClick={(e) => { e.stopPropagation(); onEditDecision(decision._id); }}
                  title="Modifier cette décision"
                >✏️</button>
              )}
              <div className='mosaic-number-icon'>n°{index+1}</div>
              <img
                src={decision.image_url}
                alt={decision.title}
                className="mosaic-decision-image"
              />
              <div className="mosaic-decision-details">
                <h2>{decision.title}</h2>
              </div>
              <div className='mosaic-decision-score-list-container'>
                  {pageData.content.display_score_decisions &&
                    pageData.content.display_score_decisions.map((score_info) => {
                      const score = Math.abs(decision.score[score_info.score_id]?.impact ?? 0);

                      return (
                        <div className='mosaic-decision-score-container' key={score_info.score_id}>
                          {score_info.display_type === 'multiple_icon' ? (
                            <div className="mosaic-multiple-icons">
                              {Array.from({ length: Math.abs(score) }).map((_, index) => (
                                <img key={index} className='mosaic-decision-score-icon' src={score_info.icon_url} />
                              ))}
                            </div>
                          ) : (
                            <>
                              <div>{score}</div>
                              <img className='mosaic-decision-score-icon' src={score_info.icon_url} />
                            </>
                          )}
                        </div>
                      );
                    })}
              </div>
              <div className='mosaic-decision-indicator-list-container'>
              {/* <div className='mosaic-decision-indicator-list'> */}
                  {listIndicators.map((indicator) => {
                    const impactData = decision.score[indicator];
                    if (!impactData) return null; // Si l'indicateur n'est pas affecté, on ne l'affiche pas

                    const impact = impactData.impact;
                    const iconUrl = gameStatus.score_dic[indicator]?.icon || '/default-icon.png'; // Icône de l'indicateur
                    const arrowIcon = impact > 0 ? ("https://res.cloudinary.com/dc1felxem/image/upload/v1741168463/fleche-vers-le-haut_vefvpd.png"):(
                      "https://res.cloudinary.com/dc1felxem/image/upload/v1741168460/fleche-vers-le-bas_1_rltipu.png")
                  if (impact === 0) return null;                
                  return (
                    <div className="mosaic-decision-indicator-container" key={indicator} >
                      <img className="mosaic-decision-indicator-icon" src={iconUrl} alt={indicator} />
                      <img className="mosaic-decision-indicator-icon" src={arrowIcon} alt={indicator} />
                      <span className="tooltip">{gameStatus.score_dic[indicator]?.name}</span>
                    </div>
                  );
                  
                  })}
                </div>
              {/* </div> */}


            </div>

          ))}
          {editMode && (
            <div className="mosaic-decision builder-add-card" onClick={onAddDecision} title="Ajouter une décision">
              <span className="builder-add-card-plus">+</span>
              <span>Ajouter une décision</span>
            </div>
          )}
        </div>
        {!editMode && displayButton && (
          <button
            className="orange-button"
            onClick={handleValidation}
            disabled={!valideConstraint}
          >
            Valider
          </button>
        )}
      </div>
    </div>
  );
};

export default MosaicPage;